export const CAPTAIN_WORKING_SUMMARIES_LIST = "CAPTAIN_WORKING_SUMMARIES_LIST";
export const CAPTAIN_WORKING_SUMMARIES_CREATE = "CAPTAIN_WORKING_SUMMARIES_CREATE";
export const CAPTAIN_WORKING_SUMMARIES_UPDATE = "CAPTAIN_WORKING_SUMMARIES_UPDATE";
export const CAPTAIN_WORKING_SUMMARIES_DELETE = "CAPTAIN_WORKING_SUMMARIES_DELETE";
export const CAPTAIN_WORKING_SUMMARIES_SHOW = "CAPTAIN_WORKING_SUMMARIES_SHOW";
